class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const galleryContent = this.querySelector('[data-gallery-content]');
    const activeMediaId = this.openedBy.getAttribute('data-media-id');
    const activeMediaOffset = this.querySelector(
      `[data-media-id="${activeMediaId}"]`,
    ).offsetTop;

    galleryContent.scrollTop = activeMediaOffset;
  }
}

customElements.define('product-modal', ProductModal);
